import React, { useEffect, useRef, useState, useMemo } from "react";
import usePaginationQueryParameter from "hooks/usePaginationQueryParameter";
import ForwardersContext, { getForwarderContextById } from "./ForwardersContext";
import { ForwardersActions } from "../stores/ForwardersStore";
const PaginatedForwarderListProvider = ({ initialPagination = {}, children }) => {
  const { page, pageSize, resetPage } = usePaginationQueryParameter();
  const [forwarders, setForwarders] = useState([]);
  const [forwardersPagination, setForwardersPagination] = useState(void 0);
  const [forwardersContext, setForwardersContext] = useState({});
  const [requestedPagination, setRequestedPagination] = useState(initialPagination);
  const [isLoading, setIsLoading] = useState(false);
  const timeout = useRef();
  const fetchPromise = useRef();
  const forwardersContextValue = useMemo(() => {
    const changeQuery = (query = "") => {
      resetPage();
      setRequestedPagination(
        (prevRequestedPagination = {}) => ({
          ...prevRequestedPagination,
          query,
          page: 1
        })
      );
    };
    const changeSort = (sortByField, order) => {
      resetPage();
      setRequestedPagination(
        (prevRequestedPagination = {}) => ({
          ...prevRequestedPagination,
          sortByField,
          order,
          page: 1
        })
      );
    };
    const changeStateFilter = (stateFilter) => {
      resetPage();
      setRequestedPagination(
        (prevRequestedPagination = {}) => ({
          ...prevRequestedPagination,
          stateFilter,
          page: 1
        })
      );
    };
    return {
      forwarders,
      forwardersContext,
      pagination: forwardersPagination,
      changeQuery,
      changeSort,
      changeStateFilter,
      isLoading,
      getForwarderContext: getForwarderContextById(forwardersContext)
    };
  }, [forwarders, forwardersContext, forwardersPagination, isLoading, resetPage]);
  useEffect(() => {
    const fetchForwarders = (isPeriodicalRequest = false) => {
      if (fetchPromise.current) {
        return;
      }
      setIsLoading(true);
      fetchPromise.current = ForwardersActions.list({ ...requestedPagination, page, pageSize }, isPeriodicalRequest).then((response) => {
        setForwarders(response.forwarders);
        setForwardersPagination(response.forwardersPagination);
        setForwardersContext(response.forwardersContext);
        return response;
      }).finally(() => {
        fetchPromise.current = void 0;
        setIsLoading(false);
      });
    };
    fetchForwarders();
    timeout.current = window.setInterval(() => {
      fetchForwarders(true);
    }, 5e3);
    return () => {
      fetchPromise.current = void 0;
      setIsLoading(false);
      if (timeout.current) {
        clearInterval(timeout.current);
      }
    };
  }, [requestedPagination, page, pageSize]);
  return /* @__PURE__ */ React.createElement(ForwardersContext.Provider, { value: forwardersContextValue }, children);
};
export default PaginatedForwarderListProvider;
